module.exports = __webpack_public_path__ + "img/home-logos.6e646246.svg";